import ReactDom from 'react-dom'

const Portal = ({ children, to = "portal" }) => {
	return ReactDom.createPortal((
		<>{children}</>
	), document.querySelector(`#${to}`))
}

export default Portal
